import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCrunchbaseLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			rx: 8,
			fill: "#0060FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2 9.2823C2 6.06732 6.8438 5.51516 7.64741 8.63794H6.35806C5.88462 7.65186 4.51703 7.41537 3.70993 8.18337C2.90001 8.94803 3.14865 10.2455 4.18914 10.6945C5.01076 11.0511 5.98183 10.7062 6.35806 9.92666H7.64741C6.84369 13.0465 2.00019 12.4943 2 9.2823Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.53257 7.02538C9.94836 6.75815 10.4309 6.59906 10.9311 6.56152H11.1401C13.7908 6.55605 15.0099 9.68453 12.9962 11.3149L12.9969 11.3156C12.7512 11.5171 12.4753 11.6721 12.1719 11.7814C11.3014 12.1006 10.3188 11.9975 9.54201 11.5001V11.7814H8.36791V4H9.53257V7.02538ZM12.8244 9.27965C12.7758 7.26144 9.60319 7.26144 9.55751 9.27965C9.53597 10.1481 10.2734 10.8642 11.1893 10.8643C12.1053 10.8643 12.8424 10.1481 12.8244 9.27965Z",
			fill: "white"
		})
	]
});
export default SvgCrunchbaseLogo;
